/**
 * 获取数据
  GET /assistant/temp/get
  接口ID：141756275
  接口地址：https://app.apifox.com/link/project/3794105/apis/api-141756275
 */

import { get } from "../../../../../utils";
export var apiLegacyTaskDetail = function apiLegacyTaskDetail(taskCode) {
  return get({
    url: '/cbs/project/task/detail',
    query: {
      taskCode: taskCode
    },
    loading: true,
    errorTip: true
  });
};

/**
 * com.micun.erp.cbs.biz.bean.project.ProjectTaskDetailVo
 *
 * ProjectTaskDetailVo
 */

/**
 * com.micun.erp.cbs.service.bean.vo.ActionVo
 *
 * ActionVo
 */

/**
 * TaskExt
 */

/**
 * com.micun.erp.cbs.service.entity.inner.project.FlowOrder
 *
 * FlowOrder
 */

/**
 * FormData
 */

/**
 * com.micun.form.client.model.FieldGroup
 *
 * FieldGroup
 */

/**
 * com.micun.form.client.model.Field
 *
 * Field
 */

/**
 * com.micun.form.client.model.FieldValue
 *
 * FieldValue
 */

/**
 * TaskOrder
 */

/**
 * com.micun.flow.order.api.model.order.oplog.OpLog
 *
 * OpLog
 */

/**
 * com.micun.erp.cbs.biz.bean.project.FlowOrderVo
 *
 * FlowOrderVo
 */

/**
 * TaskOrderVo
 */

/**
 * com.micun.erp.cbs.biz.bean.UserDetailVo
 *
 * UserVo
 */